import { render, staticRenderFns } from "./ArticleHeader.vue?vue&type=template&id=58ce8e3c&"
import script from "./ArticleHeader.ts?vue&type=script&lang=ts&"
export * from "./ArticleHeader.ts?vue&type=script&lang=ts&"
import style0 from "./ArticleHeader.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports